import { useContext, useState } from "react";
import "./BlogOverview.css";
import { Footer } from "./WebsiteCommon";
import { LocaleContext, ScrollContext } from "../common/App";
import { useAutoLoad, useNavigateSmart } from "../common/hooks";
import { BlogPostEntry } from "../common/BlogPostEntry";
import { useNavigate } from "react-router-dom";
import { LoadState } from "../common/enums.mjs";
import { ErrorComp } from "../common/Common";

export const BlogOverview = ({postList}) => {
    const locale = useContext(LocaleContext);
    const scroll = useContext(ScrollContext);

    const navigate = useNavigateSmart();


    // RENDER:

    const postEntryElements = [];

    if(postList) {
        for(let post of postList) {
            postEntryElements.push(
                <div>
                    <BlogPostEntry postData={post}
                            onClick={() => {
                                scroll.scrollToPlain(0, 0);
                                navigate("/blog/post/?id=" + post.id);
                            }}
                    />
                </div>
            );
        }
    }

    return (
        <div className="blog_overview head_img">
            <img className="img_width" src="/customer/images/blog_1.jpg" alt={locale.msgs.BLOG_IMG_1_ALT_TEXT}></img>

            <div className="text_box">
                <h1 className="text_big_big head_after_img">{locale.msgs.BLOG_POSTS}</h1>
            </div>

            <div className="blog_overview_posts side_padding bottom_padding">
                { postEntryElements.length === 0 ?
                    <div className="text_2">{locale.msgs.NO_BLOG_POSTS}</div>
                :
                    postEntryElements
                }
            </div>
        </div>
    );
}
